import { CampaignModel } from "@/views/loyalty/models/campaign.model"

export default class AccountListViewModel {
  constructor (Campaign, AccountAccrual, AccountEmission) {
    this.campaign = Campaign || new CampaignModel()
    this.accountAccrual = AccountAccrual || { account: '', amount: 0 }
    this.accountEmission = AccountEmission || { account: '', amount: 0 }
  }

  toCsv (delimiter) {
    const delim = delimiter || ";"
    return (
      this.campaign.name +
      delim +
      this.campaign.description +
      delim +
      this.accountAccrual.account +
      delim +
      this.accountAccrual.amount +
      delim +
      this.accountEmission.account +
      delim +
      this.accountEmission.amount +
      delim +
      "\n"
    )
  }
}
